// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";

import AskPunttChat from "./chat";

import PendingComponent from "../../components/PendingComponent";
import { canAccessAskPuntt } from "../../utils/auth";
import { authLayoutRoute } from "../auth-layout/route";
import { ticketsRoute } from "../tickets/route";

export const askPunttChatRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "ask-puntt/$chatId",
  beforeLoad() {
    if (!canAccessAskPuntt()) {
      throw redirect({ to: ticketsRoute.to });
    }
  },
  component: AskPunttChat,
  pendingComponent: PendingComponent,
  gcTime: 0,
  shouldReload: true,
  pendingMs: 0,
  pendingMinMs: 500,
});
